import React, { useMemo } from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { defineMessage, useIntl } from "react-intl";

import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";

import NoChart from "../../charts/NoChart";

const dealsPerFunnelChartTitle = defineMessage({
  id: "reports.overview.chart.dealsPerFunnel",
  defaultMessage: "Deals Per Funnel",
  description: "Deals Per Funnel chart title on the Overview page in Reports",
});

interface Props {
  data: Array<{ funnelName: Funnel["name"]; numberOfDeals: number }>;
}

const DealsPerStageChart: React.FC<Props> = ({ data }) => {
  const intl = useIntl();

  const dealsPerFunnel = useMemo(
    () =>
      data
        .filter(({ numberOfDeals }) => numberOfDeals > 0)
        .map(({ funnelName, numberOfDeals }) => ({ name: funnelName, y: numberOfDeals })),
    [data]
  );

  const pieDataDealsPerStage: Highcharts.Options = useMemo(
    () => ({
      chart: {
        height: 350,
        plotBackgroundColor: undefined,
        plotBorderWidth: undefined,
        plotShadow: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          colorByPoint: true,
          data: dealsPerFunnel,
          name: "# Deals",
          type: "pie",
        },
      ],
      title: {
        text: intl.formatMessage(dealsPerFunnelChartTitle),
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.y}</b>",
      },
    }),
    [dealsPerFunnel, intl]
  );

  return dealsPerFunnel.length > 0 ? (
    <HighchartsReact highcharts={Highcharts} options={pieDataDealsPerStage} />
  ) : (
    <NoChart chartTitle={intl.formatMessage(dealsPerFunnelChartTitle)} />
  );
};

export default DealsPerStageChart;
